
export default [
    {domain: "http://stugvardarna.skinova.se/", user: 'stugvardarna'}
]